import { render, staticRenderFns } from "./section-component.vue?vue&type=template&id=ac3ff07c&"
import script from "./section-component.vue?vue&type=script&lang=js&"
export * from "./section-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports